import { useSnapshotMetrics } from "@/hooks/useSnapshotMetrics";

const Analysis = () => {
  const { summary, suburbs, isLoading } = useSnapshotMetrics();
  const topSuburbs = suburbs.slice(0, 12);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Analysis</h1>
        <p className="text-muted-foreground">
          Configure and manage analysis workflows, data insights, and charting outputs.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card-elevated p-5">
          <p className="text-sm text-muted-foreground">Avg snapshots/property per suburb</p>
          <p className="text-3xl font-bold mt-2">
            {isLoading ? "..." : summary.avgSnapshotsPerPropertyPerSuburb.toFixed(2)}
          </p>
        </div>
        <div className="card-elevated p-5">
          <p className="text-sm text-muted-foreground">Trend vs previous 30 days</p>
          <p className="text-3xl font-bold mt-2">
            {isLoading
              ? "..."
              : summary.deltaVsPrevious30d === null
                ? "N/A"
                : `${summary.deltaVsPrevious30d >= 0 ? "+" : ""}${summary.deltaVsPrevious30d.toFixed(2)}`}
          </p>
        </div>
        <div className="card-elevated p-5">
          <p className="text-sm text-muted-foreground">Suburbs measured</p>
          <p className="text-3xl font-bold mt-2">{isLoading ? "..." : summary.suburbsMeasured}</p>
        </div>
      </div>

      <div className="card-elevated p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Snapshot Density by Suburb</h2>
          <p className="text-xs text-muted-foreground">
            Dynamic from live `properties` + `property_snapshots`
          </p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2">State</th>
                <th className="text-left py-2">Suburb</th>
                <th className="text-right py-2">Properties</th>
                <th className="text-right py-2">Avg snapshots/property</th>
                <th className="text-right py-2">Delta vs prev 30d</th>
              </tr>
            </thead>
            <tbody>
              {topSuburbs.map((row) => (
                <tr key={`${row.state}-${row.suburb}`} className="border-b last:border-b-0">
                  <td className="py-2">{row.state}</td>
                  <td className="py-2">{row.suburb}</td>
                  <td className="py-2 text-right">{row.properties}</td>
                  <td className="py-2 text-right">{row.avgSnapshotsPerProperty.toFixed(2)}</td>
                  <td className="py-2 text-right">
                    {row.deltaVsPrevious30d === null
                      ? "N/A"
                      : `${row.deltaVsPrevious30d >= 0 ? "+" : ""}${row.deltaVsPrevious30d.toFixed(2)}`}
                  </td>
                </tr>
              ))}
              {!isLoading && topSuburbs.length === 0 && (
                <tr>
                  <td colSpan={5} className="py-3 text-center text-muted-foreground">
                    No suburb metrics available yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Analysis;
